const initialState = {
  text: '',
  accreditationDocuments: [],
};

const GET_ACCREDITATION_DOCUMENTS = 'GET_ACCREDITATION_DOCUMENTS';

export const accreditationDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCREDITATION_DOCUMENTS:
      return { ...state, accreditationDocuments: action.payload.files, text: action.payload.text };
    default:
      return state;
  }
};

export const getAccreditationDocumentsAction = (payload) => ({ type: GET_ACCREDITATION_DOCUMENTS, payload });
